import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import GenersGridView from "./GenersGridView";
import { sortDataBasedOnType } from "../../utility/jsonUtils";
import GenersBreadCrumb from "./GenersBreadCrumb";
import { getChangedItemsInArray } from "../../utility/GenersGridUtils";

export default function GenersGridContainer({ originalGenersData, props }) {

  const [updatedGenersData, setUpdatedGenersData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState([{ title: "Geners", data: null }]);
  const [breadcrumbClicked,setBreadcrumbClicked] = useState(false);
  const [modifiedData,setModifiedData] = useState(null);

  useEffect(() => {
    if (!updatedGenersData) {
      const data = sortDataBasedOnType(originalGenersData);
      setUpdatedGenersData(data);
      setBreadcrumb([{ title: "Geners", data: data }])
    }
  }, [originalGenersData])

  const getUpdateDataFromGridView = (newDataForServer) => {
    console.log("newDataForServer : ", newDataForServer)
    setUpdatedGenersData(sortDataBasedOnType(newDataForServer));
  }

  const getGridViewTempUpdateForBreadCrumb = (modifiedGenersData) => {
    const newOriginalGenersData = updateOriginalDataFromBreadcrumb(modifiedGenersData, breadcrumb);
        console.log("newOriginalGenersData : ",newOriginalGenersData);
        //setUpdatedGenersData(newOriginalGenersData)
    //console.log("modifiedGenersData : ",modifiedGenersData);
    //console.log("breadcrumb : ",breadcrumb);
    
    //setModifiedData(modifiedGenersData);
    //setBreadcrumb(prev => [...prev, { title: "Geners", data: modifiedGenersData }]);
    // setBreadcrumb(prev => {
    //   const lastBreadcrumb = prev[prev.length - 1];
    
    //   // Check if the last breadcrumb title is "Geners"
    //   if (lastBreadcrumb?.title === "Geners") {
    //     // Find differences in data (shallow comparison)
    //     const newData = modifiedGenersData.filter(
    //       newItem =>
    //         !lastBreadcrumb.data.some(
    //           existingItem => JSON.stringify(existingItem) === JSON.stringify(newItem)
    //         )
    //     );
    
    //     // If there's no new data, return prev as is
    //     if (newData.length === 0) return prev;
    
    //     // Replace the existing "Geners" breadcrumb with the updated one
    //     const updatedBreadcrumb = [...prev];
    //     updatedBreadcrumb[updatedBreadcrumb.length - 1] = {
    //       ...lastBreadcrumb,
    //       data: [...lastBreadcrumb.data, ...newData],
    //     };
    
    //     return updatedBreadcrumb;
    //   }
    
    //   // If "Geners" is not already the last breadcrumb, push a new one
    //   return [...prev, { title: "Geners", data: modifiedGenersData }];
    // });
  }

  const updateOriginalDataFromBreadcrumb = (originalData, breadcrumb) => {
    // Clone to avoid direct mutation
    const updatedData = structuredClone(originalData);
  
    const updateChildrenRecursively = (data, breadcrumbIndex) => {
      if (breadcrumbIndex >= breadcrumb.length) return data;
  
      const currentCrumb = breadcrumb[breadcrumbIndex];
      const parentCrumb = breadcrumb[breadcrumbIndex - 1];
  
      // Skip root
      if (breadcrumbIndex === 0) {
        return updateChildrenRecursively(data, breadcrumbIndex + 1);
      }
  
      return data.map(item => {
        if (item.title === parentCrumb.title) {
          return {
            ...item,
            children: updateChildrenRecursively(currentCrumb.data || [], breadcrumbIndex + 1),
          };
        }
        if (item.children) {
          return {
            ...item,
            children: updateChildrenRecursively(item.children, breadcrumbIndex),
          };
        }
        return item;
      });
    };
    
    return updateChildrenRecursively(updatedData, 0);
  };

  const currentGridItemForBreadCrumb = (modifiedGenersData,_item, _index) => {
    console.log("_item : ",_item);
    console.log("breadcrumb : ",breadcrumb);
    console.log("modifiedGenersData : ",modifiedGenersData);
    if(_item?.children)
    {
      setBreadcrumb(prev => [...prev, { title: _item?.title, data: _item?.children }]);

      // const currentBreadcrumbData = breadcrumb?.[breadcrumb?.length-1]?.data;
      // const currentBreadcrumbTitle = breadcrumb?.[breadcrumb?.length-1]?.title;
      // if(currentBreadcrumbTitle === 'Geners')
      // {
      //   console.log("Geners")
      //   // setBreadcrumb((prev)=>{
      //   //   return [...prev,{title:currentBreadcrumbTitle,data:modifiedGenersData}];
      //   // })
      // }
      // else {
      //   console.log("Others")
      // }

      //const { added, removed, modified } = getChangedItemsInArray(breadcrumb[breadcrumb?.length-1], modifiedGenersData);
      //const currentBreadcrumbData = breadcrumb?.[breadcrumb?.length-1]?.data;
      //const currentBreadcrumbTitle = breadcrumb?.[breadcrumb?.length-1]?.title;
      // if(currentBreadcrumbTitle === 'Geners')
      // {
      //   setBreadcrumb((prev)=>{
      //     return [...prev,{title:_item?.title,data:modifiedGenersData}]
      //   })
      // }
      // else {
      //   setBreadcrumb(prev => [...prev, { title: _item?.title, data: _item?.children }]);
      // }
    }
  }

  return (
    <Box sx={{ flex: 1, height: "100%", padding: 4, marginTop: 2 }}>

      {/* Title + Create + Update button in a row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        {/* BreadCrumb */}
        <GenersBreadCrumb
          breadcrumb={breadcrumb}
          setBreadcrumb={setBreadcrumb}
          setBreadcrumbClicked={setBreadcrumbClicked}
        />

        {/* Create */}
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0,
          px: 2
        }}>
          <Button
            variant="contained"
            color="success"
            sx={{ borderRadius: 2, textTransform: "none", px: 4 }}
            onClick={() => {
              setOpenModal(true);
            }}
          >
            Create
          </Button>

          {/* Update */}
          <Button
            variant="contained"
            color="error"
            sx={{ borderRadius: 2, textTransform: "none", px: 4, ml: 4 }}
            onClick={() => {  
              setUpdateModal(true);
            }}
          >
            Update
          </Button>
        </Box>

      </Box>

      <GenersGridView
        updatedGenersData={updatedGenersData}
        setUpdatedGenersData={setUpdatedGenersData}
        openModal={openModal}
        setOpenModal={setOpenModal}
        updateModal={updateModal}
        setUpdateModal={setUpdateModal}
        sendUpdateDataFromGridView={getUpdateDataFromGridView}
        currentGridItemForBreadCrumb={currentGridItemForBreadCrumb}
        getGridViewTempUpdateForBreadCrumb={getGridViewTempUpdateForBreadCrumb}
        breadcrumbClicked={breadcrumbClicked}
        setBreadcrumbClicked={setBreadcrumbClicked}
        breadcrumb={breadcrumb}
        setBreadcrumb={setBreadcrumb}
        {...props} />

    </Box>
  );
}